import { useEffect, useRef, useState } from 'react';

export default function DeferredPreviewVideo({ src, poster, className }: {
  src: string;
  poster: string;
  className?: string;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isNearViewport, setIsNearViewport] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    if (!('IntersectionObserver' in window)) {
      setIsNearViewport(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsNearViewport(true);
        observer.disconnect();
      }
    }, { rootMargin: '200px' });
    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  return (
    <video
      ref={videoRef}
      src={isNearViewport ? src : undefined}
      poster={isNearViewport ? poster : undefined}
      className={className}
      autoPlay={isNearViewport}
      muted
      loop
      playsInline
      preload="none"
      aria-hidden="true"
      onCanPlay={event => { void event.currentTarget.play().catch(() => undefined); }}
    />
  );
}
